import React from "react";
import IncrementCounter from "../../common/IncrementCounter";

function About() {
  return (
    <section className="ttm-row about-section clearfix">
      <div className="container">
        <div className="row">
          <div className="col-xl-5 col-lg-6 col-md-12">
            <div className="ttm_single_image-wrapper text-center p-10 border d-inline-block">
              <img
                className="img-fluid"
                src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/about1.jpg"
                alt="about1"
              />
            </div>
          </div>
          <div className="col-xl-7 col-lg-6 col-md-12 col-xs-12">
            <div className="padding_left30 res-991-padding_left0 res-991-padding_top30 res-991-mb_15">
              <div className="section-title">
                <div className="title-header">
                  <h3>EyeCare</h3>
                  <h2 className="title">
                    Everybody Deserves To See The World{" "}
                    <span className="ttm-textcolor-skincolor"> Clearly.</span>
                  </h2>
                </div>
                <div className="heading-seperator">
                  <span></span>
                </div>
                <div className="title-desc">
                  <p>
                    We believe that everyone deserves to see the world clearly.
                    That’s why we’ve made it our mission to provide patients
                    with the best eye doctors, the most thorough an eye’s health
                    exams, and a wide selection of eyewear delivered with the
                    personal attention you deserve .enim ad et minim veniam.
                  </p>
                </div>
              </div>
              <div className="row ttm-vertical_sep">
                <div className="col-sm-6">
                  <div className="featured-icon-box icon-align-before-title padding_right20 margin_bottom30 res-575-padding_right0">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-sm">
                        <i className="themifyicon ti-check-box"></i>
                      </div>
                    </div>
                    <div className="featured-title">
                      <h3>We’re Certified</h3>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          Certified by Government for excellence in Ophthalmic
                          Technology
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="featured-icon-box icon-align-before-title padding_left15 res-991-padding_left0 margin_bottom30 res-575-margin_bottom0">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-sm">
                        <i className="themifyicon ti-check-box"></i>
                      </div>
                    </div>
                    <div className="featured-title">
                      <h3>
                        {
                          <IncrementCounter
                            intialCount={15}
                            startYear={2025}
                            incrementPerYear={1}
                          />
                        }
                        + Years Of Experience
                      </h3>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          Community health and vision care to the area for over{" "}
                          {
                            <IncrementCounter
                              intialCount={15}
                              startYear={2025}
                              incrementPerYear={1}
                            />
                          }
                          + years
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ttm-horizontal_sep width-100 sm-hide"></div>
              <div className="row ttm-vertical_sep">
                <div className="col-sm-6">
                  <div className="featured-icon-box icon-align-before-title padding_right10 margin_top30 res-575-padding_right0">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-sm">
                        <i className="themifyicon ti-check-box"></i>
                      </div>
                    </div>
                    <div className="featured-title">
                      <h3>Expert Doctors</h3>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          You will be treated with the most friendly &
                          compassionate care
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="featured-icon-box icon-align-before-title padding_left15 res-991-padding_left0 margin_top30">
                    <div className="featured-icon">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-sm">
                        <i className="themifyicon ti-check-box"></i>
                      </div>
                    </div>
                    <div className="featured-title">
                      <h3>Excellent Services</h3>
                    </div>
                    <div className="featured-content">
                      <div className="featured-desc">
                        <p>
                          Today, we fit into the perfect frame of services for
                          everyone
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
